import React, { useState, useEffect } from 'react'
import {Phone, Mail, Menu, X} from 'lucide-react'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'backdrop-blur-2xl bg-black/70 shadow-2xl' : 'backdrop-blur-3xl bg-black/30'}`}>
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex flex-wrap justify-center sm:justify-end items-center gap-4 sm:gap-6 text-xs sm:text-sm">
            <a href="mailto:contact@autostar13.com" className="flex items-center gap-2 text-white/80 hover:text-blue-400 transition-colors">
              <Mail size={16} />
              <span>contact@autostar13.com</span>
            </a>
            <a href="tel:+33412333650" className="flex items-center gap-2 text-white font-semibold hover:text-blue-400 transition-colors">
              <Phone size={16} />
              <span>04 12 33 36 50</span>
            </a>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <img 
              src="https://static.lumi.new/material/1c/1c27b5241cc52be5b5d029ebb47804a8.png" 
              alt="Auto Star Logo" 
              className="h-28 sm:h-32 lg:h-36 w-auto object-contain transition-transform duration-300 hover:scale-105 drop-shadow-2xl" 
            />
          </div>

          <nav className="hidden lg:flex items-center gap-8 flex-1 justify-center">
            <a href="#agence" className="text-white/90 hover:text-blue-400 transition-colors font-medium text-base tracking-wide">Agence</a>
            <a href="#prestations" className="text-white/90 hover:text-white transition-colors font-medium text-base tracking-wide">Prestations</a>
            <a href="#vehicules" className="text-white/90 hover:text-red-400 transition-colors font-medium text-base tracking-wide">Véhicules</a>
            <a href="#atouts" className="text-white/90 hover:text-blue-400 transition-colors font-medium text-base tracking-wide">Atouts</a>
          </nav>

          <div className="hidden lg:block">
            <a href="#contact" className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-6 py-2.5 rounded-full font-bold text-base hover:from-blue-500 hover:to-blue-400 transition-all shadow-lg hover:shadow-blue-500/50 hover:scale-105">Contact</a>
          </div>

          <button 
            className="lg:hidden text-white p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="lg:hidden mt-6 pb-4 border-t border-white/10 pt-6 flex flex-col gap-4 animate-in fade-in slide-in-from-top-5 duration-300">
            <a href="#agence" className="text-white/90 hover:text-blue-400 transition-colors font-medium text-lg text-center" onClick={() => setIsMenuOpen(false)}>Agence</a>
            <a href="#prestations" className="text-white/90 hover:text-white transition-colors font-medium text-lg text-center" onClick={() => setIsMenuOpen(false)}>Prestations</a>
            <a href="#vehicules" className="text-white/90 hover:text-red-400 transition-colors font-medium text-lg text-center" onClick={() => setIsMenuOpen(false)}>Véhicules</a>
            <a href="#atouts" className="text-white/90 hover:text-blue-400 transition-colors font-medium text-lg text-center" onClick={() => setIsMenuOpen(false)}>Atouts</a>
            <a href="#contact" className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 py-3 rounded-full font-bold text-lg hover:from-blue-500 hover:to-blue-400 transition-all text-center" onClick={() => setIsMenuOpen(false)}>Contact</a>
          </nav>
        )}
      </div>
    </header>
  )
}
